import Modal from 'react-modal';
import { MainButton } from '../MainButton';

import './index.css'

type ModalDeliveryProps = {
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;
    backgroundButton?: string;
    fontButton?: string;
    termContent: string;
    acceptTerm: boolean;
    setAcceptTerm: (value: boolean) => void;
}

export function ModalTerms({ termContent, isOpen, setIsOpen, backgroundButton, fontButton, acceptTerm, setAcceptTerm }: ModalDeliveryProps) {

    return(
        <Modal
            isOpen={isOpen}
            onRequestClose={() => setIsOpen(false)}
            className="modal-terms"
            contentLabel="Endereço para entrega"
            overlayClassName="overlay-modal"
            ariaHideApp={false}
        >
            <div className="modal-terms-content">
                <div className="modal-terms-body">
                    <div className="terms"dangerouslySetInnerHTML={{__html: termContent}}>
                    </div>
                    <div className="term-accept">
                        <div className="options">
                            <div className="option">
                                <input type="radio" name="term" checked={acceptTerm === true} onChange={() => setAcceptTerm(true)} />
                                <label>Aceito</label>
                            </div>
                            <div className="option">
                                <input type="radio" name="term" checked={acceptTerm === false} onChange={() => setAcceptTerm(false)} />
                                <label>Não aceito</label>
                            </div>
                        </div>
                    </div>
                    <div className="term-button">
                        <MainButton 
                            color={fontButton ? fontButton : '#FFFFFF'}
                            backgroundColor={backgroundButton ? backgroundButton : 'linear-gradient(135deg, #4338ca 0%, #764ba2 100%)'} 
                            text='Confirmar' 
                            onClick={() => setIsOpen(false)} 
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
}



type NewModalDeliveryProps = {
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;
    backgroundButton?: string;
    fontButton?: string;
    termContent: string;
    acceptTerm: boolean;
    setAcceptTerm: (value: boolean) => void;
    setReadTerms: (value: boolean) => void;
    readTerm: boolean
}


export function NewModalTerms({ termContent, isOpen, setIsOpen, backgroundButton, fontButton, acceptTerm, setAcceptTerm, readTerm,setReadTerms }: NewModalDeliveryProps) {

    return(
        <Modal
            isOpen={isOpen}
            onRequestClose={() => setIsOpen(false)}
            className="modal-terms"
            contentLabel="Endereço para entrega"
            overlayClassName="overlay-modal"
            ariaHideApp={false}
        >
            <div className="modal-terms-content">
                <div className="modal-terms-body">
                    <div className="terms"dangerouslySetInnerHTML={{__html: termContent}}>
                    </div>
                    <div className="term-accept">
                        <div className="options">
                            <div className="option">
                                <input type="radio" name="term" checked={acceptTerm === true} onChange={() => setAcceptTerm(true)} />
                                <label>Aceito</label>
                            </div>
                            <div className="option">
                                <input type="radio" name="term" checked={acceptTerm === false} onChange={() => setAcceptTerm(false)} />
                                <label>Não aceito</label>
                            </div>
                        </div>
                    </div>
                    <div className="term-button">
                        <MainButton 
                            color={fontButton ? fontButton : '#FFFFFF'}
                            backgroundColor={backgroundButton ? backgroundButton : 'linear-gradient(135deg, #4338ca 0%, #764ba2 100%)'} 
                            text='Confirmar' 
                            onClick={() => {
                                setReadTerms(true)
                                setIsOpen(false)
                            }} 
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
}